import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.login');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-login',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/page.login/view.scss */
/* src/app/page.login/view.scss: no such file or directory */`],
})
export class PageLoginComponent implements OnInit {
    public mode: string = 'login';
    public loading: boolean = false;
    public samlError: boolean = false;
    public message: string = '';
    public error: string = '';
    public resetToken: string = '';
    public loginForm: any = { email: '', password: '' };
    public signupForm: any = this.blankSignup();
    public forgotForm: any = { email: '' };
    public resetForm: any = { new_password: '', confirm_password: '' };

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        const params = new URLSearchParams(location.search);
        this.samlError = params.get('saml_error') === '1';
        this.resetToken = params.get('reset_token') || '';
        const inviteEmail = params.get('invite_email') || '';
        if (inviteEmail) {
            this.signupForm.email = inviteEmail;
            this.mode = 'signup';
        }
        if (this.resetToken) this.mode = 'reset';
        if (this.service.auth.check()) {
            location.href = this.postLoginPath();
            return;
        }
        await this.service.render();
    }

    public blankSignup() {
        return {
            name: '',
            email: '',
            mobile: '',
            signup_purpose: '',
            password: '',
            confirm_password: ''
        };
    }

    public canUseProjectCatalog(user: any = null) {
        const session = user || this.service.auth.session || {};
        if (session.can_create_project_catalog === true) return true;
        return ['admin', 'internal', 'user'].includes(session.role || 'user');
    }

    public postLoginPath(user: any = null) {
        return this.canUseProjectCatalog(user) ? '/projects/mine' : '/projects/participating';
    }

    public async setMode(mode: string) {
        this.mode = mode;
        this.message = '';
        this.error = '';
        await this.service.render();
    }

    public samlLogin() {
        const redirect = encodeURIComponent('/projects/mine');
        location.href = `/auth/saml/login/season/index?redirect=${redirect}`;
    }

    public async login() {
        this.loading = true;
        this.message = '';
        this.error = '';
        await this.service.render();

        const { code, data } = await wiz.call('login', { data: JSON.stringify(this.loginForm) });
        this.loading = false;
        if (code === 200) {
            location.href = this.postLoginPath(data.user);
            return;
        }
        this.error = data.message || '로그인하지 못했습니다.';
        await this.service.render();
    }

    public async signup() {
        const signupPurpose = String(this.signupForm.signup_purpose || '').trim();
        if (!signupPurpose) {
            this.message = '';
            this.error = '가입 목적을 입력해주세요.';
            await this.service.render();
            return;
        }
        this.signupForm.signup_purpose = signupPurpose;
        this.loading = true;
        this.message = '';
        this.error = '';
        await this.service.render();

        const { code, data } = await wiz.call('signup', { data: JSON.stringify(this.signupForm) });
        this.loading = false;
        if (code === 200) {
            this.signupForm = this.blankSignup();
            this.message = data.message || '회원가입 신청이 접수되었습니다.';
            this.mode = 'login';
        } else {
            this.error = data.message || '회원가입 신청을 처리하지 못했습니다.';
        }
        await this.service.render();
    }

    public async requestPasswordReset() {
        this.loading = true;
        this.message = '';
        this.error = '';
        await this.service.render();

        const { code, data } = await wiz.call('request_password_reset', { data: JSON.stringify(this.forgotForm) });
        this.loading = false;
        if (code === 200) {
            this.message = data.message || '가입된 이메일이면 비밀번호 재설정 안내가 발송됩니다.';
        } else {
            this.error = data.message || '비밀번호 재설정 요청을 처리하지 못했습니다.';
        }
        await this.service.render();
    }

    public async resetPassword() {
        this.loading = true;
        this.message = '';
        this.error = '';
        await this.service.render();

        const payload = Object.assign({ token: this.resetToken }, this.resetForm);
        const { code, data } = await wiz.call('reset_password', { data: JSON.stringify(payload) });
        this.loading = false;
        if (code === 200) {
            this.resetForm = { new_password: '', confirm_password: '' };
            this.resetToken = '';
            history.replaceState(null, '', '/login');
            this.mode = 'login';
            this.message = data.message || '비밀번호가 재설정되었습니다.';
        } else {
            this.error = data.message || '비밀번호를 재설정하지 못했습니다.';
        }
        await this.service.render();
    }
}

export default PageLoginComponent;